import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import {postApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
//import EventEmitter from '../utils/emmiter';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './css/footer.css';

class Footer extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			counter: "0",
		};
  };

  
  
  async componentDidMount() {
		let params = new URLSearchParams();
		const x = await postApi('/api/v2/footer', params);
		this.setState({counter: x.data.counter});
	}

	componentWillUnmount() {
	}

	render() {
		const user = this.context;
		const counter = 
			this.state.counter.split('').map((e, i) => {
        return (
					<li key={i} className="p-footer-counter">{e}</li>
				)
			})
		return (
			<footer className="footer">
				<Row className="footer-inner">
					<Col xs={12} sm={6} lg={3} className="text-vertical">
						<div>
							<Link to="/"><img className="logo-365" src="/images/365_Logo-4.png" alt="Mix365 Logo" /></Link><br />
							<div style={{fontWeight: 600, paddingTop: 6, fontSize: 14}}>The online station bringing you more than just great music</div>
						</div>
					</Col>
					<Col xs={6} sm={6} lg={2}>
						<ul className="footer-links">
							<li style={{color: 'var(--main-primary-color)'}}>Mix365</li>
							<li><Link to="/hyper">Hyper Live</Link></li>
							<li><Link to="/evolution">Evolution Live</Link></li>
							<li><Link to="/previous-sets">Previous Sets</Link></li>
							<li><Link to="/hyper/schedule">Schedule</Link></li>
						</ul>
					</Col>
					<Col xs={6} sm={6} lg={2}>
						<ul className="footer-links">
							<li style={{color: 'var(--main-primary-color)'}}>My Account</li>
							<li><Link to={`/${user?.user?.user?.username.toLowerCase().replaceAll(' ','_')}`}>My Profile</Link></li>
							<li><Link to="/mix365djs">Mix365 DJ's</Link></li>
							<li><Link to="/listen">Ways to Listen</Link></li>
							<li><Link to="/shop">Shop</Link></li>
						</ul>
					</Col>
					<Col xs={6} sm={6} lg={2}>
						<ul className="footer-links">
							<li style={{color: 'var(--main-primary-color)'}}>Company</li>
							<li><Link to="/about">About Us</Link></li>
							<li><Link to="/privacy">Privacy Policy</Link></li>
							<li><Link to="/contact">Contact Us</Link></li>
							<li><Link to="/apply">Apply To DJ</Link></li>
						</ul>
					</Col>
					<Col xs={6} sm={6} lg={3}>
						<ul className="footer-links">
							<li style={{color: 'var(--main-primary-color)'}}>Download the Android App</li>
							<li>
								<a href="" className="footer-google">
									<span className="footer-google-play">
										<FontAwesomeIcon icon="play" size="2x" />
									</span>
									<span className="footer-google-text">
										<span className="footer-google-geton">
											Get it on
										</span>
										<b className="footer-google-google">
											Google Play
										</b>
									</span>
								</a>
							</li>
							<li>Visitors</li>
							<li>
								<ul className="footer-counter">
									{counter}
								</ul>
							</li>
						</ul>
						{/*Text the Studio<br />
						+447451273036<br />*/}
					</Col>
				</Row>
				<Row>
					<Col className="footer-copyright">
						2019-2025 ©Mix365 Radio, www.mix365.co.uk. All rights reserved.
					</Col>
				</Row>
			</footer>
		);
	}
}

export default Footer;
